<style lang="scss">
.gdt-row {
  padding: 2rem;

  .table {
    border: 2px solid #dee2e6;

    .br {
      border-right: 2px solid #dee2e6;
    }

    thead {
      th {
        padding: 3rem 0;
      }

      .product-row {
        font-size: 4rem;
      }

      .product-type-row {
        font-size: 4rem;

        th {
          font-weight: normal;
        }
      }
    }

    tbody {
      font-size: 5rem;
      font-weight: bold;

      td {
        padding: 2rem 0;
      }

      span {
        display: inline-block;
        line-height: 5rem;

        &:not(.seller-name) {
          font-size: 6rem;
        }
      }
    }
  }
}
</style>

<template>
  <v-row
    class="gdt-row"
  >
    <v-col
      :size="12"
    >
      <table
        class="table table--stripe text-center"
      >
        <thead>
          <tr class="product-row">
            <th class="br">
              GDT
            </th>
            <th
              colspan="2"
              class="br"
            >
              WMP
            </th>
            <th
              class="br"
            >
              SMP
            </th>
            <th
              class="br"
            >
              AMF
            </th>
            <th
              class="br"
            >
              Butter
            </th>
            <th
              class="br"
            >
              Cheddar
            </th>
          </tr>
          <tr class="product-type-row">
            <th class="br">
              Contract 2
            </th>
            <th>Regular</th>
            <th class="br">
              Instant
            </th>
            <th class="br">
              Medium
            </th>
            <th class="br">
              Premium
            </th>
            <th class="br">
              Unsalted
            </th>
            <th class="br">
              Young
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td class="br">
              <span class="seller-name">Fonterra</span>
            </td>
            <gdt-value-cell
              v-for="(value, index) in gdt['fonterra']"
              :key="index"
              :index="index"
              :value="value"
            />
          </tr>
          <tr>
            <td class="br">
              <span class="seller-name">Arla EU</span>
            </td>
            <gdt-value-cell
              v-for="(value, index) in gdt['arla']"
              :key="index"
              :index="index"
              :value="value"
            />
          </tr>
        </tbody>
      </table>
    </v-col>
  </v-row>
</template>

<script>
import GdtValueCell from '@/views/Home/Valorization/Gdt/GdtValueCell';

export default {
  name: 'GdtRow',
  components: {
    GdtValueCell,
  },
  props: {
    gdt: {
      type: Object,
      required: true,
    },
  },
};
</script>
